import { Button, Group, Paper, Stack, Text } from '@mantine/core'
import { IconArrowLeft } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router'
import { LabelingTypeChip } from '@/components/annotations/LabelingTypes/LabelingTypeChip'
import { ModelStepperHandler } from '@/components/models/ModelDetails/ModelStepperHandler'
import { ModelStatus } from '@/components/models/ModelStatus/ModelStatus'
import { ModelTypeChip } from '@/components/models/ModelTypeChip/ModelTypeChip'
import { useApplicationContext } from '@/providers/ApplicationContext'
import { useModelContext } from '@/providers/ModelContext'
import { ApplicationNestedPath, buildAppLink } from '@/router/paths'
import { ApplicationType } from '@/types/app'

export const ModelDetailsSidebar = () => {
  const { application } = useApplicationContext()
  const { model } = useModelContext()

  if (!application || !model) {
    return null
  }

  return (
    <Paper p={8}>
      <Stack gap="lg">
        <Button
          variant="outline"
          size="xs"
          leftSection={<IconArrowLeft size={16} />}
          component={Link}
          to={buildAppLink(application.id, ApplicationNestedPath.models)}
        >
          <FormattedMessage id="models.backToMyModels" />
        </Button>

        <Paper bg="gray.1" p="sm">
          <Stack>
            <Text size="md" fw={600}>
              {model.name}
            </Text>

            {model.status !== null && <ModelStatus status={model.status} />}

            <Group gap={4}>
              <LabelingTypeChip labelingType={model.labeling_type} />

              {application.application_type === ApplicationType.MultiStage && (
                <ModelTypeChip modelType={model.model_type} />
              )}
            </Group>
          </Stack>
        </Paper>

        <ModelStepperHandler appId={application.id} model={model} />
      </Stack>
    </Paper>
  )
}
